import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { landingForRoles } from "@/lib/rolePolicy";

export default function RoleRouter() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  React.useEffect(() => {
    if (loading) return;
    if (!user) {
      nav("/login", { replace: true });
      return;
    }
    nav(landingForRoles(user.roles), { replace: true });
  }, [user, loading, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center text-[var(--text-secondary)]">
      Loading your dashboard…
    </div>
  );
}
